<div class="d-flex ion-align-items-baseline counter">
  {{ title }}
  <span *ngIf="count > 0" class="circle-indicator ms-2">{{ count }}</span>
</div>
